var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Invite Driver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 10.937 0 10.937 5.09665 0 5.09665"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Invite-Driver",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 6.323650)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.997,2.17175 C7.456,2.27075 8.038,2.48175 8.724,2.80075 C8.782,2.82775 8.823,2.86475 8.858,2.92175 C8.89,2.97475 8.909,3.02375 8.913,3.07375 L2.023,3.07375 C2.028,3.01775 2.044,2.96675 2.078,2.91075 C2.108,2.85875 2.144,2.82575 2.195,2.80175 C2.883,2.48175 3.467,2.27075 3.93,2.17175 C4.867,1.97475 6.071,1.97275 6.997,2.17175 M10.573,1.83475 C10.331,1.45875 9.988,1.16875 9.548,0.96775 C8.752,0.61775 8.032,0.36675 7.407,0.22175 C6.143,-0.07425 4.802,-0.07325 3.522,0.22075 C2.891,0.36675 2.168,0.61775 1.38,0.96475 C0.935,1.15375 0.588,1.44775 0.35,1.83675 C0.117,2.21475 0,2.63975 0,3.10175 L0,4.08475 C0,4.36475 0.099,4.61375 0.291,4.80475 C0.481,4.99575 0.731,5.09675 1.01,5.09675 L9.925,5.09675 C10.205,5.09675 10.454,4.99575 10.644,4.80675 C10.835,4.61575 10.937,4.36575 10.937,4.08475 L10.937,3.10175 C10.937,2.63675 10.815,2.21075 10.573,1.83475",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.8662,2.253 C5.0232,2.096 5.2152,2.022 5.4682,2.022 C5.7212,2.022 5.9132,2.096 6.0702,2.253 C6.2282,2.41 6.3012,2.602 6.3012,2.856 C6.3012,3.109 6.2282,3.3 6.0702,3.457 L6.0692,3.458 C5.7562,3.773 5.1812,3.774 4.8662,3.457 C4.7082,3.3 4.6342,3.109 4.6342,2.856 C4.6342,2.602 4.7082,2.411 4.8662,2.253 M7.5172,0.806 L7.5172,0.806 C6.9822,0.271 6.2932,0 5.4682,0 C4.6442,0 3.9542,0.271 3.4182,0.806 C2.8832,1.342 2.6122,2.031 2.6122,2.856 C2.6122,3.68 2.8832,4.369 3.4182,4.905 C3.9552,5.44 4.6442,5.712 5.4682,5.712 C6.2922,5.712 6.9822,5.44 7.5172,4.905 C8.0522,4.37 8.3242,3.681 8.3242,2.856 C8.3242,2.031 8.0522,1.342 7.5172,0.806",
    id: "Fill-4",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1492,4.2245 L12.1212,4.2245 L12.1212,3.1975 C12.1212,2.7275 11.7412,2.3465 11.2702,2.3465 C10.8002,2.3465 10.4202,2.7275 10.4202,3.1975 L10.4202,4.2245 L9.3932,4.2245 C8.9232,4.2245 8.5422,4.6055 8.5422,5.0755 C8.5422,5.5445 8.9232,5.9265 9.3932,5.9265 L10.4202,5.9265 L10.4202,6.9535 C10.4202,7.4235 10.8002,7.8045 11.2702,7.8045 C11.7412,7.8045 12.1212,7.4235 12.1212,6.9535 L12.1212,5.9265 L13.1492,5.9265 C13.6192,5.9265 13.9992,5.5445 13.9992,5.0755 C13.9992,4.6055 13.6192,4.2245 13.1492,4.2245",
    id: "Fill-6",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.99197a442a52f605ca8fb478251c681f.svg";
export { ForwardRef as ReactComponent };